// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1u3To","buttons":"Footer_buttons__21TDN"};